window.addEventListener("DOMContentLoaded", () => {
  // Highlighting Code Blockに色を付ける
  const hcbElems = document.querySelectorAll(".hcb_wrap");
  const hcbElemsArr = Array.prototype.slice.call(hcbElems);
  hcbElemsArr.forEach((elem) => {
    const childElem = elem.querySelector("pre");

    if (childElem.classList.contains("language-js")) {
      elem.classList.add("custom-hcb_wrap-js");
      elem.setAttribute("data-lang", "JavaScript");
    } else if (childElem.classList.contains("language-html")) {
      elem.classList.add("custom-hcb_wrap-html");
      elem.setAttribute("data-lang", "HTML");
    } else if (childElem.classList.contains("language-css")) {
      elem.classList.add("custom-hcb_wrap-css");
      elem.setAttribute("data-lang", "CSS");
    } else if (childElem.classList.contains("language-scss")) {
      elem.classList.add("custom-hcb_wrap-scss");
      elem.setAttribute("data-lang", "SCSS");
    } else if (childElem.classList.contains("language-jsx")) {
      elem.classList.add("custom-hcb_wrap-jsx");
      elem.setAttribute("data-lang", "JSX");
    } else if (childElem.classList.contains("language-php")) {
      elem.classList.add("custom-hcb_wrap-php");
      elem.setAttribute("data-lang", "PHP");
    } else if (childElem.classList.contains("language-plane")) {
      elem.classList.add("custom-hcb_wrap-plane");
    }
  });
});
